// import React from "react";
import face from "../../Assets/card.JPG";

import SocialMedia from "../../Assets/SocialMedia.jpg";

const Section3 = () => {
  return (
    <div className="relative w-full">
      {/* Background Split */}
      <div className="absolute top-0 left-0 w-full h-1/4 bg-[#F2EFEA] z-[-1]"></div>
      <div className="absolute top-1/4 left-0 w-full h-3/4 bg-white z-[-1]"></div>

      {/* Main Content Container */}
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="flex flex-col-reverse md:flex-row items-start justify-between gap-8 md:gap-16 md:py-10 ">
          {/* Left Column: Content */}
          <div className="w-full md:w-1/2 pt-8 md:pt-32 md:pl-36 md:text-justify text-left">
            <h1
              className="text-3xl md:text-4xl mb-6 text-left "
              style={{
                fontFamily: "Blacker Pro Display",
              }}
            >
              Your brand's online image is the key to its real-world success
            </h1>
            <p
              className="text-gray-600 lg:text-xl leading-relaxed tracking-wide"
              style={{
                fontFamily: "Lato-Regular",
              }}
            >
              Your online presence is a direct reflection of your brand, and
              it's essential to ensure it resonates with your audience. At
              Connect Engage Grow, we believe social media should go beyond
              aesthetics - it should tell your story, engage your community, and
              drive meaningful results.
            </p>
            <br />
            <p
              className="text-gray-600 lg:text-xl leading-relaxed tracking-wide"
              style={{
                fontFamily: "Lato-Regular",
              }}
            >
              By combining strategic marketing with your unique brand voice, we
              create content that not only attracts attention but also fosters
              genuine connections. Are you ready to stand out and leave a
              lasting impression?
            </p>
          </div>

          {/* Right Column: Image */}
          <div className="w-[70%] md:w-1/2 mt-20 -mb-10 md:-mt-32">
            <img
              src={SocialMedia}
              alt="Portrait"
              className="w-[90%] max-w-[450px] h-auto object-cover rounded-lg shadow-md mx-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section3;
